"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleArrayType = void 0;
const errors_1 = require("./errors");
const parseSchema_1 = require("./parseSchema");
const toBreadcrumb_1 = require("./toBreadcrumb");
const handleArrayType = function ({ path, schema, direction }) {
    if (!schema.items) {
        throw new errors_1.errors.SchemaInvalid(`Property 'items' at '${toBreadcrumb_1.toBreadcrumb(path)}' is missing.`);
    }
    if (Array.isArray(schema.items)) {
        throw new errors_1.errors.SchemaInvalid(`Property 'items' at '${toBreadcrumb_1.toBreadcrumb(path)}' must not be an array.`);
    }
    const { typeName: graphqlTypeName, typeDefinitions: graphqlTypeDefinitions } = parseSchema_1.parseSchema({ path, schema: schema.items, direction });
    return {
        typeName: `[${graphqlTypeName}]`,
        typeDefinitions: graphqlTypeDefinitions
    };
};
exports.handleArrayType = handleArrayType;
